import { render, staticRenderFns } from "./SsoLinkAccountPane.vue?vue&type=template&id=408b34ee&scoped=true"
import script from "./SsoLinkAccountPane.vue?vue&type=script&lang=js"
export * from "./SsoLinkAccountPane.vue?vue&type=script&lang=js"
import style0 from "./SsoLinkAccountPane.vue?vue&type=style&index=0&id=408b34ee&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "408b34ee",
  null
  
)

export default component.exports